import i18n from '../../utils/i18n'

export const PercentBodyTemplate = (percentage?: number) => {
  if (percentage == null) return null

  const { language } = i18n

  function formatPercentage(number?: number) {
    return (
      number?.toLocaleString(language, {
        minimumFractionDigits: 2,
      }) + ' %'
    )
  }

  return <>{formatPercentage(percentage)}</>
}
